<template>
  <main class="mobile-page success-screen">
    <div class="mobile-screen">
      <section class="success-panel">
        <i class="success-mark">
          <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#04110f" stroke-width="3" stroke-linecap="round"><path d="M4.5 12.5 10 18 19.5 7" /></svg>
        </i>
        <span class="mobile-eyebrow">Registration Complete · 注册完成</span>
        <h1>账号创建成功</h1>
        <p>现在可以下载点指之间 APP，开始你的数字价值之旅。</p>

        <div class="summary">
          <div><span>手机号</span><strong>{{ maskedPhone }}</strong></div>
          <div v-if="success.inviteCode"><span>邀请码</span><strong>{{ success.inviteCode }}</strong></div>
          <div><span>来源渠道</span><strong>{{ success.source || 'official' }}</strong></div>
        </div>

        <RouterLink class="mobile-btn mobile-btn-primary" to="/mobile/download?from=register">下载 APP</RouterLink>
        <RouterLink class="mobile-btn mobile-btn-ghost" to="/mobile">返回移动官网</RouterLink>
      </section>
    </div>
  </main>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue'

const success = ref({})

onBeforeMount(() => {
  const raw = sessionStorage.getItem('dzzj_register_success')
  if (!raw) {
    window.location.replace('/mobile/download')
    return
  }
  try {
    success.value = JSON.parse(raw) || {}
  } catch {
    window.location.replace('/mobile/download')
  }
})

const maskedPhone = computed(() => {
  const phone = String(success.value.phone || '')
  return phone ? phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2') : '已注册账号'
})
</script>

<style scoped>
.success-screen { display:flex; flex-direction:column; justify-content:center; }
.success-panel { display:flex; flex-direction:column; align-items:center; padding:36px 18px; text-align:center; }
.success-mark { width:74px; height:74px; display:flex; align-items:center; justify-content:center; border-radius:50%; background:radial-gradient(circle at 30% 25%,#8df5de,#46d6b6 60%,#2eb898); box-shadow:0 16px 44px rgba(70,214,182,.35); }
.success-panel h1 { margin:12px 0 8px; font-size:28px; font-weight:900; }
.success-panel > p { max-width:300px; color:var(--mobile-muted); font-size:12px; line-height:1.75; }
.summary { width:100%; margin:20px 0 20px; padding:4px 16px; border:1px solid var(--mobile-line); border-radius:16px; background:linear-gradient(165deg,rgba(18,30,50,.62),rgba(9,18,33,.78)); text-align:left; }
.summary div { display:flex; justify-content:space-between; gap:14px; padding:11px 0; border-bottom:1px dashed rgba(222,246,255,.09); }
.summary div:last-child { border-bottom:none; }
.summary span { flex:none; color:var(--mobile-quiet); font-size:11.5px; font-weight:600; }
.summary strong { color:var(--mobile-ink); font-size:12px; font-weight:800; word-break:break-all; text-align:right; }
.success-panel .mobile-btn { width:100%; }
.success-panel .mobile-btn + .mobile-btn { margin-top:10px; }
</style>
